import MediaPage from '@/components/Posts/Posts';

const Posts = () => {
 
  return (
    <>
    <div >
        <div>
            <MediaPage />
        </div>
    </div>
    </>
  );
};

export default Posts;
